import React from 'react';
import { NuvoImporter, RejectSubmitResult } from 'nuvo-react';
import _ from 'lodash';
import '../styles.css';
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useMutation, useApolloClient } from '@apollo/client';
import { getMessage } from '../translations';


const TransactionalApp = () => {
  const client = useApolloClient();
  const navigate = useNavigate();
  const licenseKey = process.env.REACT_APP_LICENSE_KEY;
  const handleGoBack = () => {
    navigate(-1); // Navigates back one step
  };
  const handleNavigateWeb = () => {
    window.open(`${process.env.REACT_APP_TRANSPORT_RATE_HAROLD_WEB_URL}`, '_blank');
  }

  const result = '';


  return (
    <div className='App'>
      <div className='container-wrapper'>
        <div>
          <div className=' FlexCenter'>
            {result !== '' ?
              <button className=' back-btn' onClick={handleNavigateWeb}>
                {getMessage('Check out transport rates on web app')}
              </button>
              :
              <NuvoImporter
                licenseKey={licenseKey}
                settings={''}
                onResults={(result, errors, complete, logs) =>
                  handleImportResult(result, errors, complete, logs)
                }
                onEntryInit={(row, rowIndex) => {

                }}

              >
                {getMessage('Import transport rate')}
              </NuvoImporter>
            }
            <button className=' back-btn' onClick={handleGoBack}>
              {getMessage('GO_BACK')}
            </button>
          </div>
          {result !== '' ?
            <div className='white-box'>
              {Object.keys(result).length !== 0 && (
                <pre>
                  {typeof result === 'string'
                    ? result
                    : JSON.stringify(result, null, 2)}
                </pre>
              )}
            </div>
            :
            <></>
          }
        </div>
      </div>
    </div>
  );
};
export default TransactionalApp;
